export default __webpack_public_path__ + "static/media/element_spec_34.9255c8c7.webp";